<template>
<div class="content">
	<!-- Content Header (Page header) -->
	<section class="content-header">
		<div class="container-fluid">
			<div class="page-header">
				<h1>Семействa</h1>
			</div>
		</div>
	</section>

	<!-- Main Content -->
	<div class="container-fluid" v-if="dataReady">

	<div class="card">
		<div class="card-block row">

		<div class="col-md-6 col-lg-3" v-for="familyInfo in records.items">

			<div class="card card-cascade narrower">

					<!--Card image-->
					<div class="view overlay hm-white-slight">
						<div class="background img-fluid" :style="{backgroundImage: 'url(\'' + (familyInfo.photo || '/network/static/img/default_family_photo.jpg') + '\')'}"></div>
						<router-link :to="'/family/' + familyInfo.id">
							<div class="mask waves-effect waves-light"></div>
						</router-link>
					</div>
					<!--/.Card image-->

					<!--Card content-->
					<div class="card-block text-center">
							<!--Title-->
							<h4 class="card-title">
								{{ familyInfo.name }}
								<small v-if="familyInfo.paid"><i class="fa fa-star-o"></i></small>
							</h4>
							<!--Text-->
							<p class="card-text">{{ $config.lists.countries[familyInfo.country].text }} / {{ $config.lists.states[familyInfo.state].text }}</p>
					</div>
					<div class="card-footer text-center">
						<p>
							<span v-for="child in familyInfo.users" class="child-age text-gray" :title="child.name">
								<i class="child-icon fa" :class="child.role == 'son' ? 'fa-male':'fa-female'"></i> {{ getChildAge(child) }}г
							</span>
						</p>
					</div>
					<!--/.Card block-->
			</div><!--/.card-->
		</div>
		</div><!-- end of external card-block -->
		<div class="row">
			<div class="col-sm-12">
				<f-pager :total="records.total" :clickhandler="pageClick"></f-pager>
			</div>
		</div>
	</div>
</div>
</div>
</template>

<script>
module.exports = {
	data: function () {
		return {
			records: [],
			dataReady: false
		};
	},
	created: function () {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function (pageNum) {
			pageNum = pageNum || 1;
			this.$http.get('backend://family?limit=' + this.$config.rpp + '&page=' + pageNum).then((response) => {
				this.records = response.body;
				this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		},
		pageClick: function (pageNum) {
			this.fetchData(pageNum);
		},
		getChildAge: function (child) {
			var currentYear = new Date().getFullYear();
			return (currentYear - child.birthYear);
		}
	}
};
</script>
<style>
.overlay .background {
	height: 170px;
	width: 100%;
	transition: all .2s linear;
	border-bottom-left-radius: 0;
	border-bottom-right-radius: 0;
	background-position: center;
	background-size: cover;
}

.card-profile {
	max-height: 300px;
}
.child-icon {
	font-size: 20px;
	margin-top: 5px;
}
.child-age {
	font-size: 12px;
	margin:0 2px;
}
.card-footer p {
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	min-height: 26px;
}
</style>



// WEBPACK FOOTER //
// FamilyList.vue?73248ae9